document.addEventListener("DOMContentLoaded", () => {
	const productCategorySingleSwipers = document.querySelectorAll(".product-category-single__mobile-swiper");

	if (productCategorySingleSwipers.length > 0) {
		productCategorySingleSwipers.forEach((carousel) => {
			const carouselId = carousel.id;

			const swiper = new Swiper(carousel, {
				// Optional parameters
				spaceBetween: 30,
				keyboard: true,
				slidesPerView: 1,

				pagination: {
					el: `#${carouselId} .product-category-single__mobile-swiper-pagination .swiper-pagination`,
					type: "fraction",
				},
				navigation: {
					nextEl: `#${carouselId} .product-category-single__mobile-swiper-navigation .swiper-button-next`,
					prevEl: `#${carouselId} .product-category-single__mobile-swiper-navigation .swiper-button-prev`,
				},
			});
		});
	}
});
